import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { Badge, Popover, Button, List } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getMyNotifications } from '../../utils/apiService';

const NotificationBell = ({ collapsed }) => {
  const navigate = useNavigate();
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);

  const prevNotificationCount = useRef(0);
  const prevNotifications = useRef([]);
  const requestVersion = useRef(0);

  const fetchNotifications = useCallback(async () => {
    const version = ++requestVersion.current;
    try {
      const response = await getMyNotifications();
      if (version !== requestVersion.current) return;
      const { unReadCount, messages } = response.data.data || { unReadCount: 0, messages: [] };

      if (unReadCount !== prevNotificationCount.current) {
        setNotificationCount(unReadCount);
        prevNotificationCount.current = unReadCount;
      }

      const limitedMessages = messages.slice(0, 3);
      if (JSON.stringify(limitedMessages) !== JSON.stringify(prevNotifications.current)) {
        setNotifications(limitedMessages);
        prevNotifications.current = limitedMessages;
      }
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
    }
  }, []);

  useEffect(() => {
    fetchNotifications();
    window.addEventListener('notifications:changed', fetchNotifications);
    return () => {
      ++requestVersion.current;
      window.removeEventListener('notifications:changed', fetchNotifications);
    };
  }, [fetchNotifications]);

  const notificationContent = useMemo(() => (
    <div>
      <List
        dataSource={notifications}
        renderItem={(item) => (
          <List.Item
            style={{
              width: 400,
              padding: '12px 20px',
              opacity: item.solveStatus === 1 ? 0.6 : 1,
              backgroundColor: item.solveStatus === 1 ? '#f5f5f5' : 'transparent'
            }}
          >
            <List.Item.Meta
              title={<span>{item.messageContent || item.title}</span>}
              description={
                <div>
                  <div style={{ fontWeight: 'bold' }}>MBL: {item.mblNo || '-'}</div>
                  <div style={{ color: '#1f63fb' }}>HBL: {item.hblNo || '-'}</div>
                  <div style={{ color: '#8c8c8c', fontSize: 12 }}>
                    Time: {item.createTime ? new Date(item.createTime).toLocaleString() : '-'}
                  </div>
                </div>
              }
            />
          </List.Item>
        )}
      />
      <Button
        type="link"
        onClick={() => navigate('/notify')}
        style={{ width: '100%', marginTop: 8 }}
      >
        View More
      </Button>
    </div>
  ), [notifications, navigate]);

  return (
    <Popover content={notificationContent} title="" placement="topRight"
      onOpenChange={(open) => { if (open) fetchNotifications(); }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          marginBottom: 12,
          cursor: 'pointer',
          padding: '8px 24px',
          borderRadius: '4px',
          transition: 'background-color 0.3s'
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
      >
        <Badge count={notificationCount} overflowCount={99}>
          <BellOutlined style={{ fontSize: '18px', cursor: 'pointer', color: '#1f63fb' }} />
        </Badge>
        {!collapsed && <span style={{ marginLeft: 12, fontSize: '14px' }}>Notifications</span>}
      </div>
    </Popover>
  );
};

export default NotificationBell;
